export default "__VITE_PUBLIC_ASSET__72930857__"